import Translator from '../../classes/Translator/Translator';

const HeroLogic = () => {
  const { translator } = Translator();

  return {
    translator,
  };
};

export default HeroLogic;
